<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc"/>
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <!--                            buat dialog dengan input tanggal-->
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <!--                                tombol add terms-->

                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelected"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import EzDataTable from "@/Components/EzDataTable";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import ButtonLinkAdd from "@/Components/ButtonLinkAdd";
import ButtonLinkEdit from "@/Components/ButtonLinkEdit";
import ButtonLinkShow from "@/Components/ButtonLinkShow";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit.vue";
import ButtonAdd from "@/Components/ButtonAdd.vue";
import Dialog from 'primevue/dialog';
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import {Pesan} from "@/constants";
import ButtonLink from "@/Components/ButtonLink.vue";

export default defineComponent({
    components: {
        ButtonLink,
        AppLayout,
        BreadCrumb,
        EzDataTable,
        Toolbar,
        Button,
        ButtonLinkAdd,
        ButtonLinkEdit,
        ButtonLinkShow,
        ButtonDelete,
        ButtonEdit,
        ButtonAdd,
        Dialog,
        JetLabel,
        Input,
    },
    data() {
        return {
            sk_drm: '',
            ezdtConfig: {
                dtHeader: "Daftar Terms Of Service",
                globalFilter: ["section_title"],
                sortBy: "created_at",
                defineCols: [

                    {
                        field: "section_number",
                        header: "Nomor",
                        style: "min-width: 20rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "is_active",
                        header: "Status Aktif",
                        style: "min-width: 5rem",
                        isFrozen: true,
                        col_type: "boolean",
                    },
                    {
                        field: "description",
                        header: "Deskripsi",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },


                ],
                dtSourceApiRoute: {
                    list: "terms.data",
                    show: "terms.show",
                    // edit: "penyedia.edit",
                    // destroy: "penyedia.destroy",
                },
            },
            selected: [],
            selected_id: 0,
            allow_to_proceed: true,
            displayBasic: false,
            tanggal: null,
            keterangan: null,
            lokasi: null,
        };
    },
    methods: {
        loadEzData: function () {
            // this.allow_to_proceed = false;
            this.$refs.ezdt.loadData();
        },
        getSelectedpenyedia: function (data) {
            this.selected = data;
            this.selected_id = 0;
            if (data.length == 1) {
                this.selected_id = data[0]["id"];
                console.log(this.selected_id);
            }
        },
        tambah: function (event) {
            //
        },
        edit: function (event) {
            //
        },

        onChangeFileUpload(event) {
            this.sk_drm = event.target.files[0];
            console.log(this.sk_drm);
        },
        buat: function (event) {

            let ids = [];
            this.selected.forEach(function (item, index) {
                ids.push(item.id);
            });
            // tampilkan modal
            this.displayBasic = true;

        },
        buatDaftar: function (event) {
            let ids = [];
            this.selected.forEach(function (item, index) {
                ids.push(item.id);
            });
            let formData = new FormData();
            formData.append('ids[]', ids);
            formData.append('tanggal', this.tanggal);
            formData.append('sk_drm', this.sk_drm);

            // update data
            // console.log(this.tanggal);
            axios
                .post(route("penyedia.buatDrm"), formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Success",
                        detail: response.data.msg,
                        life: 3000,
                    });
                    this.loadEzData();
                    this.displayBasic = false;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: error.response.data.msg,
                        life: 3000,
                    });
                });

        },
    },
});
</script>
